import { lazy } from 'react';
import { isChunkLoadError, reloadForChunkError } from './chunkReload';

/*
 * Drop-in replacement for React.lazy that survives a deploy.
 *
 * On a failed dynamic import it retries once (absorbs a transient network blip),
 * and if it still fails with a chunk error — the post-deploy "old hash is gone"
 * case — it reloads once to fetch the current build. While the reload is in
 * flight it returns a never-resolving promise so React keeps showing the Suspense
 * fallback instead of flashing the error boundary. A non-chunk error is rethrown
 * unchanged so genuine bugs still surface.
 */
export default function lazyWithRetry(factory) {
  return lazy(() =>
    factory().catch(() =>
      factory().catch((error) => {
        if (isChunkLoadError(error) && reloadForChunkError()) {
          return new Promise(() => {});
        }
        throw error;
      })
    )
  );
}
